import { Injectable } from '@angular/core';
import { ApiConfig } from './config.api';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable()
export class FundPerformanceResourceApi {
  constructor(private httpClient: HttpClient) {
  }

  getHistory(searchString, fromDate, toDate, currentlanguage) {
    const params = new HttpParams()
      .set('searchString', searchString)
      .set('fromDate', fromDate)
      .set('toDate', toDate)
      .set('lang', currentlanguage);

    return this.httpClient.get(ApiConfig.baseURL + 'api/fundperformance/history', {headers: ApiConfig.requestOptionsHeader, params: params});
  }
}
